import { useLingui } from '@lingui/react/macro';
import { createFileRoute } from '@tanstack/react-router';

import { FormPage } from '@/components/page/FormPage';
import { ChatForm } from '@/features/chats/components/ChatForm';

export const Route = createFileRoute('/_baseLayout/chats/create')({
  component: ChatsCreatePage,
});

export function ChatsCreatePage() {
  const { t } = useLingui();

  return (
    <FormPage
      title={t`Create chat`}
      breadcrumbs={[
        { label: t`Chats` },
        { label: t`Create chat`, to: '/chats/create' },
      ]}
    >
      <ChatForm />
    </FormPage>
  );
}
